// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2267":"392cab68","4196":"e35605b7","4644":"5affe6a8","6162":"f51b39b1"}[chunkId] + ".chunk.css";
};